export enum UserRoleEnum {
  SUPER_ADMIN = 'super_admin',
  ADMIN = 'admin',
  HOMEOWNER = 'homeowner',
  PARTNERS = 'partner'
}

export const isAdminRole = (role) =>
  [UserRoleEnum.ADMIN, UserRoleEnum.SUPER_ADMIN].includes(role);
